import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function CompanyTypeList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();
 
  function hascomptypeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("company type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hascomptypeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("company type");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  const columns = [
    { field: "CT_Id", label: "#" },
    { field: "CT_Name", label: "Company Type" },
    { field: "CT_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hascomptypeEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.CT_Id));

        navigate(
          `/CompanyTypeLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean);
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/CompanyType/list`}
      actions={actions}
      title={`Company Type`}
      {...(hascomptypeAddprivilege(privilegeData) && {
        linkvalue: `/CompanyTypeLookup/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default CompanyTypeList;
